module.exports = __webpack_public_path__ + "static/media/screenshot03.bd78fa89.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/screenshot03.png
// module id = 185
// module chunks = 0